module.exports = __webpack_public_path__ + "img/1.6634af54.jpg";